import { PREFIX, URIType } from "../uri";

export class UserURI {
  type: URIType.User = URIType.User;
  tenantId: string;
  objectId: string;

  static parse(text: string) {
    const parts = text.split(":");
    if (parts.length !== 4 || parts[1] !== "user") {
      return null;
    }

    const [, , tenantId, objectId] = parts.map(decodeURIComponent);

    return new UserURI(tenantId, objectId);
  }

  static fromString(text: string) {
    const uri = UserURI.parse(text);
    if (!uri) {
      throw new Error("Not UserURI");
    }
    return uri;
  }

  constructor(tenantId: string, objectId: string) {
    this.tenantId = tenantId;
    this.objectId = objectId;
  }

  toString(): string {
    return [PREFIX, "user", this.tenantId, this.objectId]
      .map(encodeURIComponent)
      .join(":");
  }
}
